import axios from "axios";
import { createContext, useContext } from "react";
import { backend } from "../env";

const serverContext = createContext(undefined);

export const ServerProvider = ({children}) => {
    const api = axios.create({
        baseURL: backend.url,
        withCredentials: true,
    });

    const getRequest = (url, data, callback) => {
        let requestOptions =  {
            params: data,
            // headers: {
            //     'Authorization': 'Bearer ' + getToken()
            // }
        };

        api.get(url, requestOptions).then(res => {
            callback([true, res.data]);
        }).catch((res) => {
            callback([false, res]);
        });
    }

    const postRequest = (url, data, callback) => {
        let requestOptions =  {
            // headers: {
            //     'Authorization': 'Bearer ' + getToken()
            // }
        };

        api.post(url, data, requestOptions).then(res => {
            callback([true, res.data]);
        }).catch((res) => {
            callback([false, res]);
        });
    }

    const value = {
        getRequest,
        postRequest
    };

    return (
        <serverContext.Provider
            value={value}
        >
            {children}
        </serverContext.Provider>
    );
}

export const useServer = () => useContext(serverContext);